import { format, isValid, parse, parseISO } from 'date-fns';
export function parseAndFormatDate(date: any): string | null {
  if (!date) return null;

  let parsedDate: Date;

  if (typeof date === 'string') {
    // Tenta dd/MM/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
      parsedDate = parse(date, 'dd/MM/yyyy', new Date());
    } else {
      // ISO ou outros formatos aceitos
      parsedDate = parseISO(date);
    }
  } else {
    parsedDate = date;
  }

  return isValid(parsedDate)
    ? format(parsedDate, "yyyy-MM-dd'T'HH:mm:ss.SSSX")
    : null;
};
